export default __webpack_public_path__ + "static/media/SG-MNDA-2021.bc644fe2.pdf";